import { render, staticRenderFns } from "./HouseIcon.vue?vue&type=template&id=8f402064&scoped=true&"
import script from "./HouseIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HouseIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f402064",
  null
  
)

export default component.exports